import { Box } from "@mui/material";
import { tokens } from "../../theme";

/**
 * Contador redondo del kit: el número que acompaña a una pestaña o a un ítem de
 * la barra lateral. `resaltar` lo pinta con el naranjo de aviso cuando lo que
 * cuenta exige acción (solicitudes o revisiones pendientes); en cero vuelve al
 * gris neutro, porque ya no hay nada que atender.
 */
export default function Contador({ n, resaltar }: { n: number; resaltar?: boolean }) {
  const fuerte = !!resaltar && n > 0;
  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        minWidth: 22,
        px: 0.75,
        py: 0.1,
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.6,
        textAlign: "center",
        bgcolor: fuerte ? tokens.naranjo[400] : tokens.etiqueta.neutra.bg,
        color: fuerte ? tokens.neutro.texto : tokens.etiqueta.neutra.fg,
      }}
    >
      {n}
    </Box>
  );
}
